import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getDashOrderStatusListByUserid, getOrderStatusListbyAfid,setofUpdatedashboardOrderTV,decrypt,encrypt
} from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import {Grid} from '@material-ui/core'
//import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
  const { OrderStatusList,updatedashboardOrderTY} = accountsData;
    const { OrderStatusAntalList,DashboardOrderFilterOption} = DashBoard;
    return {
        authUser,OrderStatusAntalList,OrderStatusList,DashboardOrderFilterOption,updatedashboardOrderTY
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getDashOrderStatusListByUserid: (Afid,userid,DashboardOrderFilterOption) => dispatch(getDashOrderStatusListByUserid(Afid,userid,DashboardOrderFilterOption)),
        getOrderStatusListbyAfid: (Afid,isFrom) => dispatch(getOrderStatusListbyAfid(Afid,isFrom)),
        setofUpdatedashboardOrderTV: () => dispatch(setofUpdatedashboardOrderTV()),
     
        dispatch
    };
}

class OrderTable extends Component {
    state={
        OrderStatusAntalList:[],
        DashboardOrderFilterOption:isEmpty(this.props.DashboardOrderFilterOption)?[]:this.props.DashboardOrderFilterOption,
        done: false,
        intervaltype:1
      }
      intervalID = null
      componentDidMount=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        axios.get(`kontos/DashBoard/OANORSByAfud`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
          if(res.data.success){
                                          let endata = decrypt(res.data.encryptedData,res.data.iv)
                                          let ndate = JSON.parse(endata)
                                          this.setState({ 
                                            OrderStatusAntalList:ndate.results.OrderStatusAntalList,
                                            intervaltype:this.props.intervaltype
                                         });
                                         this.initiateInterval() 
                                        // this.setState({done: true})    
                                      }
        
        })
      }
      initiateInterval() {
          clearInterval(this.intervalID);
          this.intervalID= null
        this.intervalID = setInterval(
          () => {
            if(this.state.done === true){ 
              this.setState({done:false})
              const userid = this.props.authUser.user_id;
              const Afid = this.props.authUser.user_Afid;
           axios.get(`kontos/DashBoard/OANORSByAfud`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
          if(res.data.success){
            let endata = decrypt(res.data.encryptedData,res.data.iv)
            let ndate = JSON.parse(endata)
            this.setState({ 
              OrderStatusAntalList:ndate.results.OrderStatusAntalList,
              intervaltype:this.props.intervaltype
           });
           this.initiateInterval() 
          // this.setState({done: true})    
        }
        })
        
            }
          },
          180000
      );
       
      }
      componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
      }
     componentDidUpdate=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(parseInt(this.props.updatedashboardOrderTY) === 1){
          axios.get(`kontos/DashBoard/OANORSByAfud`,
          { params:encrypt(JSON.stringify({
              Afid:Afid,
              FilterOption:[],
              intervaltype:this.props.intervaltype,
              userid:userid
            }))
          })
          .then(res => {
            if(res.data.success){
              let endata = decrypt(res.data.encryptedData,res.data.iv)
              let ndate = JSON.parse(endata)
              this.setState({ 
                OrderStatusAntalList:ndate.results.OrderStatusAntalList,
                intervaltype:this.props.intervaltype
             });
             this.initiateInterval() 
            // this.setState({done: true})    
          }
          })
          this.props.setofUpdatedashboardOrderTV()
      }
      if(!isUndefined(this.props.intervaltype)){
        if(parseInt(this.props.intervaltype) !== parseInt(this.state.intervaltype)){
          axios.get(`kontos/DashBoard/OANORSByAfud`,
          { params:encrypt(JSON.stringify({
              Afid:Afid,
              FilterOption:[],
              intervaltype:this.props.intervaltype,
              userid:userid
            }))
          })
          .then(res => {
            if(res.data.success){
              let endata = decrypt(res.data.encryptedData,res.data.iv)
              let ndate = JSON.parse(endata)
              this.setState({ 
                OrderStatusAntalList:ndate.results.OrderStatusAntalList,
                intervaltype:this.props.intervaltype
             });
             this.initiateInterval() 
            // this.setState({done: true})    
          }
          })
        }
      }
    }
      getStalus=(n)=>{
        console.log(n)
        return (
          <div style={{ color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor, height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2">
          <div style={{ color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,height: '15px', width: '15px', borderRadius: '50%', backgroundColor:n.color , marginRight: '15px' }}></div>
          <p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{n.Meta}</p>
        </div>
        )
      
      }
    render() {
      // console.log('test5655', this.props.OrderStatusList )
        return (
            <div style={{width:'95%',overflowY: "auto",height: '100%'}}>
               
                 {
                 !isEmpty(this.state.OrderStatusAntalList)?this.state.OrderStatusAntalList.map((n,index) => {
                    return (
                        <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{justifyContent: "space-between"}}
                        > 
                        <Grid item >{this.getStalus(n)}</Grid>
                        <Grid item style={{color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}}><span style={{fontSize:35, fontWeight: '400'}}>{n.Antal}</span>st</Grid>
                        </Grid>
                    )
                 })
                 :""}   
               
                    
               
            </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(OrderTable);